














import { Component, mixins } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import AdminCreateUserForm from '@/modules/user/components/admin/forms/AdminCreateUserForm.vue'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'

@Component({
  components: {
    AdminCreateUserForm,
    Modal
  }
})
export default class AdminCreateUserDialog extends mixins(DialogMixin) {
  private modalVisibility: boolean = false
}
